export interface CalibrationData {
    associatedTestEvents: AssociatedTestEvent[];
}

export interface AssociatedTestEvent {
    assessmentRunId: number;
    assessmentRunTitle: string;
    assessmentRunStartTime: string;
    assessmentRunEndTime: string;
    name: string;
    contentItemId: number;
    contentRevisionId: number;
    versionName: string;
    versionNumber: number;
    contentVersionId: number;
    exposureCount: number;
    location: string;
}

export type CalibrationDataState = {
    data?: CalibrationData;
    pageNo: number;
    hitsPerPage: number;
    loading: boolean;
    errorFetching: unknown;
    errorDownloading: unknown;
    errorAccess: unknown;
}

export enum CalibrationDataActions {
    CALIBRATION_DATA_REQUEST = 'CALIBRATION_DATA_REQUEST',
    CALIBRATION_DATA_SUCCESS = 'CALIBRATION_DATA_SUCCESS',
    CALIBRATION_DATA_FAILURE = 'CALIBRATION_DATA_FAILURE',
    CALIBRATION_DATA_FAILURE_DOWNLOAD = 'CALIBRATION_DATA_FAILURE_DOWNLOAD',
    CALIBRATION_DATA_FAILURE_ACCESS = 'CALIBRATION_DATA_FAILURE_ACCESS',
    SET_CURRENT_PAGE = 'SET_CURRENT_PAGE',
    SET_HITS_PER_PAGE = 'SET_HITS_PER_PAGE',
    RESET_STATE = 'RESER_STATE',
    REMOVE_ACCESS_ERROR = 'REMOVE_ACCESS_ERROR',
    REMOVE_DOWNLOAD_ERROR = 'REMOVE_DOWNLOAD_ERROR',
}

export type CalibrationDataActionsType = {
    type: CalibrationDataActions;
    payload?: CalibrationData;
    pageNo?: number;
    hitsPerPage?: number;
    searchText?: string;
}

export type fetchCalibrationDataSagaActiontype = {
    type: CalibrationDataActions.CALIBRATION_DATA_REQUEST;
    searchText?: string;
}
